import React from 'react';
import { getFormattedDateTimeWithoutYearRange } from '@lmt/unicorn-shared/app/components/patients/common';

import styles from './CurrentVisitsPanel.module.scss';

export interface CurrentVisitInfo {
  id: number;
  room: string;
  startDate: Date;
  endDate: Date;
  patientId: number;
  patientName: string;
  subtenantCode: string;
  caseId: number;
  visitType: string;
}

export interface Props {
  visit: CurrentVisitInfo;
  hasPlaceColumn: boolean;
  openPatientTab: (patientId: number) => void;
  openCaseVisitTab: (
    patientId: number,
    caseId: number,
    visitId: number,
  ) => void;
}

export const CurrentVisitItem: React.FC<Props> = (props) => {
  const { visit, hasPlaceColumn, openPatientTab, openCaseVisitTab } = props;

  return (
    <tr
      key={visit.id}
      onClick={() => openCaseVisitTab(visit.patientId, visit.caseId, visit.id)}
    >
      <td className={styles.timeRange}>
        {getFormattedDateTimeWithoutYearRange(visit.startDate, visit.endDate)}
      </td>
      <td
        className={styles.patientInfo}
        onClick={(e) => {
          e.stopPropagation();
          openPatientTab(visit.patientId);
        }}
      >
        <div className={styles.patientContainer}>
          <div className={styles.patient}>
            <div className={styles.patientName} title={visit.patientName}>
              {visit.patientName}
            </div>
          </div>
          <div className={styles.subtenantCode}>{visit.subtenantCode}</div>
        </div>
      </td>
      {/*<td className={styles.subtenantCode}>{visit.subtenantCode}</td>*/}
      <td className={styles.visitType}>{visit.visitType}</td>
      {hasPlaceColumn && <td className={styles.place}>{visit.room}</td>}
    </tr>
  );
};
